import * as React from 'react';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles.scss';

interface IWysiwygProps {
  name: string;
  value?: string | undefined;
  onChange?: Function;
}

interface IWysiwygState {
  editorState: Editor;
}

class Wysiwyg extends React.Component<IWysiwygProps, IWysiwygState> {

  constructor(props: IWysiwygProps) {
    super(props);

    this.state = {
      editorState: props.value
        ? EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(props.value || '')))
        : EditorState.createEmpty(),
    };

    this.onChange = this.onChange.bind(this);
  }

  // todo: to by mělo fungovat, ale v editoru to neustále skáče na začátek ...
  // componentWillReceiveProps(nextProps: IWysiwygProps) {
  //     if (nextProps.value !== this.props.value) {
  //         this.setState({
  //             editorState: EditorState.createWithContent(
  //                 ContentState.createFromBlockArray(
  //                     convertFromHTML(nextProps.value || ''))),
  //         })
  //     }
  // }

  public render() {
    const { editorState } = this.state;

    return (
      <React.Fragment>
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onChange}
        />
      </React.Fragment>
    );
  }

  private onChange(editorState: EditorState) {
    this.setState({
      editorState
    }, () => {
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          }
        });
      }
    });
  }
}

export default Wysiwyg;


// WEBPACK FOOTER //
// ./src/components/Form/components/Wysiwyg/Wysiwyg.tsx